/**
 * Orange “Legacy” chip for full Promotions entry points (drawer, workspace card).
 * Theme warning palette — same family as auction UI accents.
 * Standalone module avoids HMR / chunk edge cases with larger layout bundles.
 */
export const LEGACY_PROMOTIONS_WATERMARK_CHIP_SX = {
  fontSize: "0.65rem",
  height: 20,
  flexShrink: 0,
  bgcolor: "warning.light",
  color: "warning.dark",
  fontWeight: 700,
  letterSpacing: 0.02,
  "& .MuiChip-label": { px: 0.75 },
};
